import React from 'react'
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
import { CotizacionesAdminPage } from './admin/CotizacionesAdminPage'
// import { CotizacionesDetailPage } from './detail/CotizacionesDetailPage'
import { PlanificacionCotizacionesPage } from './tabs/PlanificacionCotizaciones/PlanificacionCotizacionesPage';

const CotizacionesRoutes = () => {
    const { path } = useRouteMatch();
    const history = useHistory()
    
    return (
        <Switch>
            <Route path={`${path}/cotizaciones-admin`} render={(props) => (<CotizacionesAdminPage {...props} history={history} />)} />
            {/* <Route path={`${path}/cotizaciones`} component={CotizacionesDetailPage} />
            <Route path={`${path}/cotizaciones/:id`} component={CotizacionesDetailPage} /> */}
            <Route path={`${path}/cotizaciones/:id`} render={(props) => (<PlanificacionCotizacionesPage {...props} history={history} /> )}/>
            
        </Switch>
    )
}
export default CotizacionesRoutes; 
